import { Injectable } from '@angular/core'

import { AEMCONTENT_MOCK } from '../../mock-files/aem-content-mock.json'
@Injectable({
  providedIn: 'root',
})
export class ContentService {
  AEMContent: {}

  constructor() {
    this.AEMContent = AEMCONTENT_MOCK
  }

  getContent(
    contentType: string,
    contentFragmentName: string,
    variation?: string,
  ): string {
    variation = variation ? variation : 'master'
    return this.AEMContent[
      contentType + '-' + contentFragmentName + '-' + variation
    ]
  }
}
